import { render } from "./NewsView.vue?vue&type=template&id=4dfa8674"
import script from "./NewsView.vue?vue&type=script&lang=js"
export * from "./NewsView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__